import { Injectable, signal, WritableSignal } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {

  // add signal for loading

  public isLoadingSignal: WritableSignal<boolean> = signal(false, { equal: _.isEqual });
  public isLoading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  /**
   * Set loading state
   * @param loading True or false 
   */
  public isLoading(loading: boolean): void {
    this.isLoading$.next(loading);
    this.isLoadingSignal.set(loading);
  }
}
